import React from 'react';
import PropTypes from 'prop-types';
import styles from './Radio.module.scss';

const Radio = ({
  checked,
  onChange,
  disabled,
  name,
  value,
  label,
  id,
  className,
  ...rest
}) => {
  const wrapperClasses = [
    styles.wrapper,
    disabled ? styles.disabled : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <label htmlFor={id} className={wrapperClasses}>
      <span className={styles.controlWrap}>
        <input
          id={id}
          type="radio"
          name={name}
          value={value}
          className={styles.input}
          checked={!!checked}
          onChange={onChange}
          disabled={disabled}
          {...rest}
        />
        <span className={styles.box} aria-hidden="true">
          <span className={styles.dot} />
        </span>
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
};

Radio.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
};

Radio.defaultProps = {
  checked: false,
  onChange: () => {},
  disabled: false,
  name: undefined,
  value: undefined,
  label: null,
  id: undefined,
  className: '',
};

export default Radio;
